/*
Игнорирования ошибки "ResizeObserver loop limit exceeded". Данная ошибка, судя по всему, некритична.
https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded/50387233#50387233
https://github.com/juggle/resize-observer/issues/103
*/
export const hideResizeObserverRunTimeError = (e: any) => {
  if (
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message ===
      'ResizeObserver loop completed with undelivered notifications.'
  ) {
    const resizeObserverErrDiv = document.getElementById(
      'webpack-dev-server-client-overlay-div'
    );
    const resizeObserverErr = document.getElementById(
      'webpack-dev-server-client-overlay'
    );
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none');
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none');
    }
  }
};
